module.exports = __webpack_public_path__ + "img/gratification-pdf.8ec5e9a8.svg";